/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ChooseType/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Ach from './Ach/index'
import Card from './Card/index'
import React from 'react'
import Widget from './Widget/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function ChooseType({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/PaymentsTreatmentPlan/Content/TreatmentPayments/Content/Content/SetupPayment/ActiveStep/AutopaymentSetup/Pay/ChooseType"
  
}) {
let dtSpaceXl = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xl'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<div
  data-testid="ChooseType.Horizontal"
  data-view-path={viewPath}
 style={{'--pr-1-Zk451t': typeof dtSpaceXl === 'number' ? `${dtSpaceXl}px` : dtSpaceXl,'--mb-2-Zk451t': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<Card
  viewPath={`${viewPath}/Card`}
/>
<Ach
  viewPath={`${viewPath}/Ach`}
/>
</div>
<Widget
  viewPath={`${viewPath}/Widget`}
/>
{children}
</React.Fragment>)
}